import axios from 'axios';
import BASEURL from '../BaseUrl';

export const uploadFileApi = async (formData) => {
  const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
  try {
    const response = await axios.post(`${BASEURL}/business-intelligence/file-upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${parseToken}`,
      },
    });
    console.log('File uploaded successfully:', response.statusText);
    return response;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const downloadFileApi = async (file_path, cloudEnvironment) => {
  const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
  await axios
    .get(`${BASEURL}/business-intelligence/download-file`, {
      params: {
        file_path,
        cloudEnvironment,
      },
      responseType: 'blob',
      headers: { Authorization: `Bearer ${parseToken}` },
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${file_path.split('/').at(-1)}`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.error('Error downloading file:', error);
    });
};

export const deleteFileApi = async (file_path, cloudEnvironment) => {
  const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
  const response = await axios
    .delete(`${BASEURL}/business-intelligence/delete-file`, {
      params: {
        file_path,
        cloudEnvironment,
      },
      headers: { Authorization: `Bearer ${parseToken}` },
    })
    .catch((error) => {
      console.error('Error deleting file:', error);
    });
  return response;
};
export const getListOfFileMetadataApi = async (filepath, cloudEnvironment) => {
  const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
  const response = await axios.post(
    `${BASEURL}/directory/directory-content`,
    { filepath, cloudEnvironment },
    {
      headers: { Authorization: `Bearer ${parseToken}` },
    }
  );
  return response;
};

export const getPdf = async (blobName) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-processor/read-pdf`, {
      params: { blobName },
      headers: { Authorization: `Bearer ${parseToken}` },
      responseType: 'arraybuffer',
    });
  } catch (error) {
    if (error.response.status === 401) {
      // await logoutApi();
      console.log('logout');
    }

    throw error;
  }
};
